var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ListItem } from "@mui/material";
import { COLORS } from "../../../../../constants";
import { HALO } from "../../../../../constants/colors";
import { Text } from "../../../../Atoms";
import { useEffect, useRef } from "react";
var MenuItem = function (_a) {
    var menuItem = _a.menuItem, active = _a.active, handleClick = _a.handleClick, activeColor = _a.activeColor, setIndicatorData = _a.setIndicatorData;
    var myRef = useRef(null);
    // send id of menu item clicked
    var onClick = function () {
        handleClick(menuItem.id);
    };
    // set indicator data for active menu item
    // 40 default for 1 line of text
    useEffect(function () {
        var _a, _b;
        if (active) {
            setIndicatorData({
                height: ((_a = myRef === null || myRef === void 0 ? void 0 : myRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 40,
                top: ((_b = myRef === null || myRef === void 0 ? void 0 : myRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop) || 0,
            });
        }
    }, [active, myRef === null || myRef === void 0 ? void 0 : myRef.current]);
    return (_jsx(ListItem, __assign({ onClick: onClick, sx: { py: 2.5, cursor: "pointer", px: 0 }, ref: myRef }, { children: _jsx(Text, __assign({ shade: "dark", variant: active ? "subtitle2" : "body2", emphasis: menuItem.disabled ? "disabled" : "high", sx: {
                "&:hover": {
                    color: !active && !menuItem.disabled ? COLORS.P_MED_EMPHASIS : "",
                },
                color: active ? activeColor : undefined,
                "&:focus-visible": {
                    boxShadow: HALO,
                },
            } }, { children: menuItem.title })) })));
};
export default MenuItem;
